import React, { useEffect } from 'react';
import { SalesPage } from './pages/SalesPage';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    // Inicializar Meta Pixel cuando la app carga
    initMetaPixel();
  }, []);
  return <>
      <SalesPage data-id="element-0" />
      {/* Noscript fallback para Meta Pixel */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1228743476050707&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
    </>;
}